<template>
  <div class="social-networks">
    <a
      v-for="item in items"
      :key="item.name"
      :ref="item.name"
      :href="item.url"
      target="_blank"
      @click="onClick(item.name, item.url, $event)"
    >
      <f-sprite-icon :icon-link="$options.icons[`Icon${item.name}`]" />
    </a>
  </div>
</template>

<script>

import IconOk from '@icons/ok.svg';
import IconTelegram from '@icons/telegram.svg';
import IconVk from '@icons/vk.svg';

import { SOCIAL_NETWORKS } from '@/constants/contacts';
import { createGtmEventsProxy } from '@/gtm/gtm-events-utils';

export default {
  name: 'social-networks',

  icons: {
    IconVk,
    IconOk,
    IconTelegram,
  },

  inject: {
    gtmEvents: {
      default: createGtmEventsProxy(),
    },
  },

  props: {
    items: {
      type: Array,
      default: () => Object.values(SOCIAL_NETWORKS),
    },
  },

  methods: {
    onClick(network) {
      this.gtmEvents.socialLinkClick(network);
    },
  },
};
</script>

<style lang="scss">
.social-networks {
  display: flex;
  height: 40px;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: $blue;
    color: #fff;
    cursor: pointer;

    & + a {
      margin-left: 12px;
    }
  }

  .sprite-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
